const orderConfig = {
    before: { // 입금전
        filterLayout: 'OrderFilterBeforeLayout',
        listLayout: 'OrderListBeforeLayout',
        paginationLayout: 'PaginationBeforeLayout',
        listApiParamSet: {
            type : 'basic',
            f:1 , //파일정보
            oa:1,  //배송정보
            st : [10],
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        isGetFirst : true,
        isCategory : true,
        getCategoryFunc : 'getBankCode',
        excelParamSet:{
            type: 'basic',
            stat: 10,
            ip: 0,
            st: [10],
            exc:1
        },
        excelDownloadName:'입금전 주문건 목록',
    },
    complete: { // 결제완료
        filterLayout: 'OrderFilterCompleteLayout',
        listLayout: 'OrderListCompleteLayout',
        paginationLayout: 'PaginationCompleteLayout',
        listApiParamSet: {
            type : 'basic',
            st : [20],
            ip : 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            type: 'basic',
            stat :20,
            st:[20],
            ip:0,
            exc:1
        },
        excelDownloadName:'결제완료 주문건 목록',
        isGetFirst : true,
    },
    itemReady: { // 상품 준비중
        filterLayout: 'OrderFilterCompleteLayout',
        listLayout: 'OrderListItemReadyLayout',
        paginationLayout: 'PaginationItemReadyLayout',
        listApiParamSet: {
            type : 'basic',
            st : [21],
            ip : 1,
            sp :1,
            page : 1,
            oa : 1, // 배송정보
            ba : 1, // 입금정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            type: 'basic',
            stat :21,
            st:[21],
            ip:0,
            exc:1
        },
        excelDownloadName:'상품준비중 주문건 목록',
        isGetFirst : true,
    },
    preparing: { // 배송준비중
        filterLayout: 'OrderFilterDefaultLayout',
        listLayout: 'OrderListPreparingLayout',
        paginationLayout: 'PaginationPreparingLayout',
        listApiParamSet: {
            type : 'basic',
            st : [30],
            ip : 1,
            sp :1,
            page : 1,
            oa : 1, // 배송정보
            ba : 1, // 입금정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            type: 'basic',
            stat: 30,
            st : [30],
            ip:0,
            exc:1
        },
        excelDownloadName:'배송준비중 주문건 목록',
        isGetFirst : true,
    },
    shipping : { // 배송중
        filterLayout: 'OrderFilterShippingLayout',
        listLayout: 'OrderListShippingLayout',
        paginationLayout: 'PaginationShippingLayout',
        listApiParamSet: {
            type : 'basic',
            st : ['40'],
            ip : 1,
            sp :1,
            page : 1,
            oa : 1, // 배송정보
            ba : 1, // 입금정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            type: 'basic',
            stat :40,
            st:[40],
            ip:0,
            exc:1
        },
        excelDownloadName:'배송중 주문건 목록',
        isGetFirst : true,
    },
    shippingDone : { // 배송완료
        filterLayout: 'OrderFilterShippingDoneLayout',
        listLayout: 'OrderListShippingDoneLayout',
        paginationLayout: 'PaginationShippingDoneLayout',
        listApiParamSet: {
            type : 'basic',
            st : ['50','60'],
            ip : 1,
            sp :1,
            page : 1,
            oa : 1, // 배송정보
            ba : 1, // 입금정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            type: 'basic',
            stat :50,
            st : ['50','60'],
            ip:0,
            exc:1
        },
        excelDownloadName:'배송완료 주문건 목록',
        isGetFirst : true,
    },
    cancel : { // 취소관리
        filterLayout: 'OrderFilterCancelLayout',
        listLayout: 'OrderListCancelLayout',
        paginationLayout: 'PaginationCancelLayout',
        listApiParamSet: {
            ip : 1,
            // sp :1,
            // page : 1,
            // or : 1,
            // oa : 1,
            // ccl : 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrderByCancel',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'cc.created_at',
            order: 'desc'
        },
        excelParamSet:{
            ip: 0,
            excel: 1,
        },
        excelDownloadFunc: 'cart/status/cancel',
        excelDownloadName:'취소 주문건 목록',
        isGetFirst : true,
    },
    exchange : { // 교환관리
        filterLayout: 'OrderFilterExchangeLayout',
        listLayout: 'OrderListExchangeLayout',
        paginationLayout: 'PaginationExchangeLayout',
        listApiParamSet: {
            ip : 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrderByTrade',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'ct.created_at',
            order: 'desc'
        },
        excelParamSet:{
            ip: 0,
            excel: 1,
        },
        excelDownloadFunc: 'cart/status/trade',
        excelDownloadName:'교환 주문건 목록',
        isGetFirst : true,
    },
    refund : { // 환불 관리
        filterLayout: 'OrderFilterRefundLayout',
        listLayout: 'OrderListRefundLayout',
        paginationLayout: 'PaginationRefundLayout',
        listApiParamSet: {
            ip : 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrderByRefund',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'cr.created_at',
            order: 'desc'
        },
        excelParamSet:{
            ip: 0,
            excel: 1,
        },
        excelDownloadFunc: 'cart/status/refund',
        excelDownloadName:'환불 주문건 목록',
        isGetFirst : true,
    },
    /// 이하 모달
    beforeCancel :{ // 입금전 관리 상세 취소
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status:105
        },
        parsingData: {
            reason:'cc_comment' // 취소사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '취소 완료 추가 안내',
        redirectType:'back',
        closeModalName:'order-list-reason-modal'
    },
    multipleCancel:{ // 목록 다중 취소
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status:105
        },
        parsingData: {
            reason:'cc_comment' // 취소사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '취소 완료 추가 안내',
        redirectType:'reset',
        closeModalName:'order-list-reason-modal'
    },
    orderRefund :{ // 상세 환불
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 123, // 환불 123
        },
        parsingData: {
            reason : 'cr_comment', // 환불사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '환불 안내',
        redirectType:'back',
        closeModalName:'order-reason-modal',
    },
    orderChange : { // 상세 교환
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 113, // 교환
        },
        parsingData: {
            reason : 'ct_comment', // 교환사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '교환 안내',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    refundSuccess:{ // 상세 환불 승인
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 123, // 환불 승인
        },
        parsingData: {
            reason : 'cr_comment', // 환불사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '환불 승인 추가 안내',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    refundListSuccess : { // 리스트 환불 승인
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 123, // 환불 승인
        },
        parsingData: {
            reason : 'cr_comment', // 환불사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '환불 승인 추가 안내',
        closeModalName:'order-list-reason-modal',
        redirectType:'reset'
    },
    refundCancel : { // 환불 거절
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 129, // 환불 승인
        },
        parsingData: {
            reason : 'cr_comment', // 환불거절사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '거절 사유',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    exchangeListSuccess:{ // 목록 교환  승인
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 113, // 교환 승인
        },
        parsingData: {
            reason : 'ct_comment', // 교환 사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '교환 승인 추가 안내',
        closeModalName:'order-list-reason-modal',
        redirectType:'reset'
    },
    exchangeSuccess:{ // 교환 승인
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 113, // 교환 승인
        },
        parsingData: {
            reason : 'ct_comment', // 교환 사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '교환 승인 추가 안내',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    exchangeCancel:{ // 교환 거절
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 119, // 교환 거절
        },
        parsingData: {
            reason : 'ct_comment', // 교환 사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '거절 사유',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    requestSuccess : { // 취소 완료 처리
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 105, // 취소 완료
        },
        parsingData: {
            reason : 'cc_comment', // 취소 완료 사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '취소 완료 추가 안내',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    requestCancel : { // 취소 요청 거절
        writeFunc: 'updateOrderStatus',
        writeLayouts: ['OrderWriteDefaultLayout'],
        writeApiParamSet: {
            c_status : 109, // 취소 거절
        },
        parsingData: {
            reason : 'cc_comment', // 취소 거절 사유
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '상태 변경에 실패했습니다.',
        keyName: 'c_idx',
        orderTitle : '거절 사유',
        closeModalName:'order-reason-modal',
        redirectType:'back'
    },
    CreateAdminMemo :{
        writeFunc: 'updateOrder',
        writeLayouts: ['OrderWriteMemoLayout'],
        writeApiParamSet: {},
        parsingData: {
            memo : 'o_memo'
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '저장 실패하였습니다.',
        keyName: 'o_idx',
        closeModalName:'order-memo-modal',
        redirectType:'reset',
    },
    UpdateAdminMemo :{
        writeFunc: 'updateOrder',
        writeLayouts: ['OrderWriteMemoLayout'],
        writeApiParamSet: {},
        parsingData: {
            memo : 'o_memo'
        },
        writeSuccessType: true,
        writeFailTypes: {
        },
        writeFailMsg: '저장 실패하였습니다.',
        keyName: 'o_idx',
        closeModalName:'order-memo-modal',
        redirectType:'reset',
    },
    memberOrderHistory: { // 회원상세 > 구매기록
        filterLayout: 'OrderFilterMemberLayout',
        listLayout: 'OrderListMemberLayout',
        paginationLayout: 'PaginationMemberLayout',
        listApiParamSet: {
            type : 'basic',
            ip : 1,
            or : 1, // 주문정보
            oa : 1, // 배송정보
            ccl:1, //취소정보
            tr:1,  //교환정보
            rf:1,  //환불정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            exc:1
        },
        excelDownloadName:'회원 구매기록 목록',
        isGetFirst : true,
    },

    modalOrderGroupList: { // 결제완료
        filterLayout: 'OrderFilterNoneLayout',
        listLayout: 'OrderListModalInfoLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            type : 'basic',
            ip : 1,
            or : 1, // 주문정보
            oa : 1, // 배송정보
            ccl:1, //취소정보
            tr:1,  //교환정보
            rf:1,  //환불정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            exc:1
        },
        excelDownloadName:'',
        isGetFirst : true,
    },
    brandOrderHistory: { // 브랜드 상세 > 주문 내역
    filterLayout: 'OrderFilterBrandLayout',
        listLayout: 'OrderListBrandLayout',
        paginationLayout: 'PaginationMemberLayout',
        listApiParamSet: {
            type : 'basic',
            ip : 1,
            or : 1, // 주문정보
            oa : 1, // 배송정보
            ccl:1, //취소정보
            tr:1,  //교환정보
            rf:1,  //환불정보
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getOrder',
        sortOptions: {
            keyName: 'obt',
            orderName: 'obs',
        },
        defaultSort: {
            key: 'order_date',
            order: 'desc'
        },
        excelParamSet:{
            exc:1
        },
        // excelParamSet:{
        //     type: 'basic',
        //     stat :10,
        //     st:[10],
        //     ip:0,
        // },
        excelDownloadName:'브랜드 주문 내역',
        isGetFirst : true,
    },

}

export default {
    methods: {
        returnOrderConfig(type) {
            return orderConfig[type];
        },
    },
    filterConfig: {
        cr : { //주문일
            type: 'between',
            classname: 'filterDate',
        },
        or : { //결제일
            type: 'between',
            classname: 'filterDate',
        },
        it : { //배송일
            type: 'between',
            classname: 'filterDate',
        },
        iet : { //배송완료일
            type: 'between',
            classname: 'filterDate',
        },
        ccr : { //주문취소요청일
            type: 'between',
            classname: 'filterDate',
        },
        cac : { //주문취소완료일
            type: 'between',
            classname: 'filterDate',
        },
        tcr : { //교환요청일
            type: 'between',
            classname: 'filterDate',
        },
        tac : { //교환요청승인일
            type: 'between',
            classname: 'filterDate',
        },
        tre : { //교환요청거절일
            type: 'between',
            classname: 'filterDate',
        },
        tdo : { //교환요청완료일
            type: 'between',
            classname: 'filterDate',
        },
        rcr : { //환불요청일
            type: 'between',
            classname: 'filterDate',
        },
        rac : { //환불요청승인일
            type: 'between',
            classname: 'filterDate',
        },
        rre : { //환불요청거절일
            type: 'between',
            classname: 'filterDate',
        },
        ocr: { //취소,교환,환불 주문일
            type: 'between',
            classname: 'filterDate',
        },
        mid: { //아이디
            type: 'query',
            classname: 'searchInput',
        },
        oid : { //주문번호
            type: 'query',
            classname: 'searchInput',
        },
        ina : { //상품명
            type: 'query',
            classname: 'searchInput',
        },
        mo : { //관리코드
            type: 'query',
            classname: 'searchInput',
        },
        na : { //주문자
            type: 'query',
            classname: 'searchInput',
        },
        pna : { //입금자
            type: 'query',
            classname: 'searchInput',
        },
        cu : { //배송번호
            type: 'query',
            classname: 'searchInput',
        },
        ci : { //송장번호
            type: 'query',
            classname: 'searchInput',
        },
        st : { //취소상태
            type : 'match',
            classname : 'filterStatus',
            option: {
                10: {st: [10]},
                20: {st: [20]},
                21: {st: [21]},
                30: {st: [30]},
                40: {st: [40]},
                50: {st: [50]},
                60: {st: [60]},
                100: {st: [100]},
                110: {st: [110]},
                115: {st: [115]},
                120: {st: [120]},
                125: {st: [125]},
            }
        },
        ps : {//가격시작
            type : 'match',
            classname : 'filterPrice_sd'
        },
        pe : {//가격끝
            type : 'match',
            classname : 'filterPrice_ed'
        },
        bid : {//은행
            type : 'match',
            classname : 'filterBank'
        },
        cid: {//주문 상품 코드
            type: 'query',
            classname: 'searchInput',
        },
        c_id: {//주문 상품 코드
            type: 'query',
            classname: 'searchInput',
        },
        mna: {//주문자
            type: 'query',
            classname: 'searchInput',
        },
        prge : {//가격시작
            type : 'match',
            classname : 'filterPrice_sd'
        },
        prle : {//가격끝
            type : 'match',
            classname : 'filterPrice_ed'
        },
        cc_status: { //취소 상태 //0:취소요청,1:취소승인,2:취소철회
            type : 'match',
            classname : 'filterCancelStatus',
            option: {
                0: {cc_status: [0]},
                1: {cc_status: [1]},
                2: {cc_status: [2]},
            }
        },
        ct_status: { //교환 상태 //0:교환요청,1:교환승인(교환중),2:교환거절,3:교환완료
            type : 'match',
            classname : 'filterExchangeStatus',
            option: {
                0: {ct_status: [0]},
                1: {ct_status: [1]},
                2: {ct_status: [2]},
                3: {ct_status: [3]},
            }
        },
        model: {//관리코드
            type: 'query',
            classname: 'searchInput',
        },
        rst: { //환불 상태 //0:환불요청,1:환불승인(환불중),2:환불거절,3:환불완료
            type : 'match',
            classname : 'filterRefundStatus',
            option: {
                0: {cr_status: [0]},
                1: {cr_status: [1]},
                2: {cr_status: [2]},
                3: {cr_status: [3]},
            }
        },
        tab: {
            type: 'noFilter',
            classname: 'tab',
        },
    }
}
